import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileSignature } from '@fortawesome/pro-regular-svg-icons';

export const NoSignersView: React.FC = () => (
  <section className="flex flex-col items-center justify-center" data-test-id="no-signers-section">
    <FontAwesomeIcon className="w-12 h-12 text-extension-foundation-primary-variant" icon={faFileSignature} />
    <span className="text-black font-medium">No Signers</span>
  </section>
);
